module.exports = __webpack_public_path__ + "static/media/SmartShop_2-200w.822ad854.png";